import { render, staticRenderFns } from "./CategoryPartBrand.vue?vue&type=template&id=0dce0a43&scoped=true&"
import script from "./CategoryPartBrand.vue?vue&type=script&lang=js&"
export * from "./CategoryPartBrand.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPartBrand.vue?vue&type=style&index=0&id=0dce0a43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dce0a43",
  null
  
)

export default component.exports